<template>
  <div class="footer">
    <div class="main">
      <div class="content">
        <div class="left">
          <!-- <img :src="webIco" class="logo" alt="" /> -->
          <img :src="websiteInfo.footLogo" class="logo" alt="" />
          <p class="ename">{{ empName }}</p>
        </div>
        <div class="right">
          <!-- <p class="phone">{{ entpTel }}</p> -->
          <p class="phone">{{ websiteInfo.headLinkTel }}</p>
          
        </div>
      </div>
      <p class="copyright">Copyright.©2018 Etesting. All Rights Reserved.</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["webIco", "entpTel", "empName","websiteInfo"]),
  },
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  margin: 0 auto;
  padding: 0;
  background: #333;
  color: #dedede;
  overflow: hidden;
  &:before {
    display: table;
    content: "";
  }
  .main {
    width: 1200px;
    margin: 0 auto;
    .content {
      margin-top: 30px;
      &:before,&:after{
        display: table;
        content: "";
        clear: both;
      }
      .left {
        float: left;
        .logo {
          display: block;
          max-width: 300px;
          max-height: 55px;
        }
        .ename {
          font-size: 20px;
          margin-top: 20px;
        }
      }
      .right {
        float: right;
        width: 280px;
        height: 60px;
        line-height: 60px;
        font-size: 30px;
        padding-left: 62px;
        background: url("../../static/20210517new/phone.png") no-repeat center
          left;
        background-size: 56px;
      }
    }
    .copyright{
      border-top: 1px solid #666464;
      line-height: 65px;
      font-size: 13px;
      text-align: center;
      margin-top: 35px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue